<div class="text-center" *ngIf="isLoading || (checkoutService.isAnythingLoading$ | async) || (cartService.isLoadingSubject | async)">
    <div class="backdrop" style="left: 0">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>

<ng-container *ngIf="shippingDetails">
    <div class="row" style="margin: 0">
        <div class="col-sm-6 nav nav-pills nav-justified mb-3 pl-0 pr-2">
            <button 
                id="shipping-tab"
                class="nav-item nav-link shipping-button"
                [class.active]="!shippingDetails.IsPickup && !shippingDetails.ConsistsEntirelyOfDigitalItems"
                [class.inactive-button]="shippingDetails.IsPickup"
                [disabled]="shippingDetails.ConsistsEntirelyOfDigitalItems"
                (click)="changeFulfillmentMethod($event, 'shipping')"
                data-testid="shipping-method-button"
            >
                <i class="fas fa-shipping-fast"></i>Shipping
            </button>
        </div>
        <div class="col-sm-6 nav nav-pills nav-justified mb-3 pl-2 pr-0">
            <button
                id="pickup-tab" 
                class="nav-item nav-link shipping-button" 
                [class.active]="shippingDetails.IsPickup && !shippingDetails.ConsistsEntirelyOfDigitalItems"
                [class.inactive-button]="!shippingDetails.IsPickup"
                [disabled]="shippingDetails.ConsistsEntirelyOfDigitalItems"
                (click)="changeFulfillmentMethod($event, 'pickup')"
                data-testid="pickup-method-button"
            >
                <i class="fas fa-user-clock"></i>Pickup
            </button>
        </div>
    </div>

    <app-shipping-selector *ngIf="showShippingSelector"
        [shippingDetails]="shippingDetails"
        [postalCodeForm]="postalCodeForm"
        [ratesForm]="shippingRatesForm"
        [pageScope]="pageScope"
        (getNewShippingQuote)="getNewShippingQuoteFromPostalCode()"
    >
    </app-shipping-selector>

    <app-pickup-selector
        *ngIf="showPickupSelector"
        [shippingDetails]="shippingDetails"
        [storeLocations]="storeLocations"
        [locationsForm]="pickupLocationsForm" 
        [pageScope]="pageScope"
        [stockMap]="stockMap"
    >
    </app-pickup-selector>

    <hr *ngIf="shippingDetails.ConsistsEntirelyOfDigitalItems">
    <p *ngIf="shippingDetails.ConsistsEntirelyOfDigitalItems" style="color: green" data-testid="order-is-digital-label">
        All items in your order are digital. They will be delivered via email.
    </p>
    
    <div *ngIf="!shippingDetails.IsPickup && shippingQuoteRequired" data-testid="shipping-quote-required-container">
        <ng-container *ngIf="shippingDetails.HasGeocodeError && isCartPage; else showShippingQuoteRequired">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-check p-0">
                        <input type="radio" class="form-check-input" checked>
                        <label class="form-check-label active" data-testid="more-address-info-required-label">
                            More Address Info Required
                        </label>
                    </div>
                </div>
            </div>

            <div class="row small">
                <div class="col-sm-12 m-2" data-testid="more-address-info-required-text">
                    <ul>
                        <li>Unable to get live rates for your postal code.</li>
                        <li>Please visit the checkout page and enter your full address to get live rates.</li>
                    </ul>
                </div>
            </div>
        </ng-container>
        
        <ng-template #showShippingQuoteRequired>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-check p-0">
                        <input type="radio" class="form-check-input" checked>
                        <label class="form-check-label active" data-testid="shipping-quote-required-label">
                            Shipping Quote Required
                        </label>
                    </div>
                </div>
            </div>

            <div class="row small">
                <div class="col-sm-12 m-2" data-testid="shipping-quote-required-text">
                    A quote is required for one of the following reasons:
                    <ul>
                        <li>Your destination is outside of Canada.</li>
                        <li>The contents of your cart is over 10lbs.</li>
                        <li>One or more of the items are oversized.</li>
                        <li>The cost for delivery could not be determined.</li>
                    </ul>
                    <p>
                        Enter a different destination, or continue to checkout.
                    </p>
                    <p>Once your order is processed, we will send you a shipping quote for approval.
                    </p>
                </div>
            </div>
        </ng-template>
    </div>
</ng-container>